import api from "lib/axios";
import type { ApiEnvelope, PaginatedResult } from "services/apiTypes";
import { unwrapData, unwrapList } from "services/apiTypes";

export type InstructorFinancialOverview = {
  currency: string;
  total_collected: number;
  pending_requests: number;
  pending_amount: number;
  active_enrollments: number;
  free_enrollments: number;
};

export type InstructorFinancialTransaction = {
  id: number;
  type: "bundle" | "course";
  status: string;
  payment_status?: string | null;
  amount?: number | null;
  expected_amount: number;
  currency: string;
  is_free: boolean;
  student?: {
    id: number;
    name?: string | null;
    phone?: string | null;
  } | null;
  bundle?: {
    id: number;
    title?: string | null;
  } | null;
  course?: {
    id: number;
    title?: string | null;
  } | null;
  starts_at?: string | null;
  ends_at?: string | null;
  created_at?: string | null;
  reviewed_at?: string | null;
};

export type FinancialTransactionsQuery = {
  page?: number;
  limit?: number;
  status?: string;
};

function unwrapPaginated<T>(res: ApiEnvelope<PaginatedResult<T>> | undefined) {
  const result = res?.result as PaginatedResult<T> | { data?: PaginatedResult<T> } | undefined;
  if (result && "data" in result && result.data && !Array.isArray(result.data)) {
    return result.data;
  }
  return unwrapList<T>(res);
}

export const instructorFinancialService = {
  async overview() {
    const res = await api.get<ApiEnvelope<{ data: InstructorFinancialOverview }>>(
      "/instructors/financial/overview",
      { meta: { toastSuccess: false } }
    );
    return unwrapData(res.data);
  },

  async transactions(params: FinancialTransactionsQuery = {}) {
    const res = await api.get<ApiEnvelope<PaginatedResult<InstructorFinancialTransaction>>>(
      "/instructors/financial/transactions",
      { params, meta: { toastSuccess: false } }
    );
    return unwrapPaginated<InstructorFinancialTransaction>(res.data);
  },
};
